import React, { useMemo } from "react";
import SingleForum from "../components/forum/SingleForum";
import { directoryContext } from "../context/Context";
import axios from "axios";
import Pagination from "../components/pagination/Pagination";
import { Link } from "react-router-dom";

let PageSize = 2;
const Forum = () => {
  const {
    forumDispatch,
    forumState: { forums },
  } = React.useContext(directoryContext);
  const [currentPage, setCurrentPage] = React.useState(1);

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return forums
      .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
      .slice(firstPageIndex, lastPageIndex);
  }, [currentPage, forums]);

  const Recent3Forum = forums
    .sort((a, b) => a.createdAt < b.createdAt)
    .slice(0, 3);
  const fetchForums = async () => {
    try {
      const res = await axios.get(
        "https://www.api.webdirectories.info/api/forum/"
      );
      res.status === 200 &&
        forumDispatch({ type: "FETCH_FORUMS", payload: res.data.data });
    } catch (error) {
      console.log(error);
    }
  };
  React.useEffect(() => {
    fetchForums();
  }, []);

  return (
    <div className="container-fluid" style={{ background: "#f6f6f6" }}>
      <div className="d-flex align-items-center justify-content-center">
        <div
          className="d-flex align-items-center justify-content-start px-1 py-1 bg-white my-2"
          style={{ width: "80%" }}
        >
          <h4 className="text-secondary text-center">Home</h4>
          <span style={{ color: "#f38e35" }}>
            <i class="bi bi-caret-right mx-1"></i>
          </span>

          <p className="mt-3">Blog</p>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-center mt-2">
        <div style={{ width: "80%" }} className="mb-5 d-flex ">
          <div
            className=" d-flex flex-column align-items-center justify-content-start"
            style={{ flex: "0.6" }}
          >
            {currentTableData.map((forum, i) => {
              return <SingleForum forum={forum} key={i} />;
            })}
            <div className="my-5">
              <Pagination
                totalCount={forums?.length}
                pageSize={PageSize}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </div>

          <div
            className="d-flex flex-column"
            style={{ flex: "0.4", background: "#f6f6f6" }}
          >
            <div
              className=" d-flex flex-column mx-5 my-3 px-4 py-5 bg-white rounded"
              style={{ width: "90%" }}
            >
              <h5 className="text-center">Recent Post</h5>
              <hr />

              <div className="text-center  mx-2">
                {Recent3Forum.map((forum, i) => (
                  <h6 style={{ fontWeight: "400", color: "#f38e35" }} key={i}>
                    <Link to={`/forum/${forum._id}`}>{forum.title}</Link>
                  </h6>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forum;
